import { GET_STAFF_CARDS_ERROR, GET_STAFF_CARDS_START, GET_STAFF_CARDS_SUCCESS } from '../../types';

export default function get_staff_cards(state, action) {
  switch (action.type) {
    case GET_STAFF_CARDS_START:
      return { ...state };
    case GET_STAFF_CARDS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_STAFF_CARDS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
